//
// Хук для запроса у API списка объектов
//
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { get } from './api';

const useApiList = ({ method, find, skip, limit, event, dates, categories, countries, lang, where }) => {
    const [data, setData] = useState(null);
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState('');

	useEffect(() => {
		const fetchData = async (find) => {
			setIsLoading(true);
			setData(null);
			setError('');
			const dts = dates ? dates.join() : '';
			const cat = categories ? categories.join() : '';
			const ctr = countries ? countries.join() : '';
			const result = await get(method, { find, skip, limit, event, dates: dts, categories: cat, countries: ctr, lang, where });
			if(result.error) {
				setError(result.error);
			} else {
				setData(result.data);
			}
			setIsLoading(false);
		};

		fetchData(find.trim());
	}, [ method, find, skip, limit, event, dates, categories, countries, lang, where ]);

    return [ data, error, isLoading ];
};

useApiList.defaultProps = {
	event: '',
	categories: [],
	countries: [],
	lang: 'ru',
	where: 'index',
};

useApiList.propTypes = {
    method: PropTypes.string.isRequired,
    find: PropTypes.string.isRequired,
    skip: PropTypes.number.isRequired,
    limit: PropTypes.number.isRequired,
	event: PropTypes.string,
	categories: PropTypes.array,
	countries: PropTypes.array,
	lang: PropTypes.string,
	where: PropTypes.string,
};

export default useApiList;
